import { render, staticRenderFns } from "./CardStatisticsDialog.vue?vue&type=template&id=20353570&scoped=true"
import script from "./CardStatisticsDialog.vue?vue&type=script&lang=js"
export * from "./CardStatisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./CardStatisticsDialog.vue?vue&type=style&index=0&id=20353570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20353570",
  null
  
)

export default component.exports